import { useMessages, useBlockTheme } from "@quillforms/renderer-core";
import { InputMask } from "@react-input/mask";

/**
 * WordPress Dependencies
 */
import { useEffect } from "react";

/**
 * External Dependencies
 */
import tinyColor from "tinycolor2";
import { css } from "emotion";
import classnames from "classnames";


const MaskedBlock = (props) => {
  const {
    id,
    attributes,
    setIsValid,
    setIsAnswered,
    setValidationErr,
    showNextBtn,
    val,
    setVal,
    showErrMsg,
    inputRef,
    isTouchScreen,
    setFooterDisplay,
    isPreview,
    isReviewing,
  } = props;
  const theme = useBlockTheme(attributes.themeId);
  const messages = useMessages();
  const answersColor = tinyColor(theme.answersColor);
  const { required, mask, replacement, validators, uppercase } = attributes;

  const checkFieldValidation = (value) => {
    if (required === true && (!value || value === mask || value.length === 0)) {
      setIsValid(false);
      setValidationErr(
        messages["label.errorAlert.required"] || "This field is required"
      );
    } else if (value && validators && value.length > 0) {
      for(const validator of validators) {
        if (!validator.validator(value)) {
          setIsValid(false);
          setValidationErr(validator.errorMessage || "Invalid value!");
          return;
        }
      }
      setIsValid(true);
      setValidationErr(null);
    } else {
      setIsValid(true);
      setValidationErr(null);
    }
  };

  useEffect(() => {
    if (isPreview || !isReviewing) checkFieldValidation(val);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [required]);

  const changeHandler = (e) => {
    const value = e.target.value;
    checkFieldValidation(value);
    setVal(value);
    showErrMsg(false);
    if (!value) {
      setIsAnswered(false);
    } else {
      setIsAnswered(true);
      showNextBtn(true);
    }
  };

  return (
    <InputMask
      showMask
      ref={inputRef}
      className={classnames(
        css`
          & {
            width: 100%;
            border: none !important;
            outline: none;
            padding-bottom: 8px !important;
            padding-left: 0 !important;
            padding-right: 0 !important;
            border-radius: 0 !important;
            background: transparent;
            background-color: transparent !important;
            transition: box-shadow 0.1s ease-out 0s;
            -webkit-appearance: none;
            box-shadow: ${answersColor.setAlpha(0.3).toString()} 0px 1px !important;
          }

          &::placeholder {
            opacity: 0.3;
            /* Chrome, Firefox, Opera, Safari 10.1+ */
            color: ${theme.answersColor};
          }

          &:-ms-input-placeholder {
            opacity: 0.3;
            /* Internet Explorer 10-11 */
            color: ${theme.answersColor};
          }

          &::-ms-input-placeholder {
            opacity: 0.3;
            /* Microsoft Edge */
            color: ${theme.answersColor};
          }

          &:focus {
            box-shadow: ${answersColor.setAlpha(1).toString()} 0px 2px !important;
            border: none !important;
            outline: none !important;
          }

          color: ${theme.answersColor} !important;
        `
      )}
      id={"masked-" + id}
      data-ref={id}
      // type="masked"
      mask={mask}
      replacement={replacement}
      onChange={changeHandler}
      onKeyUp={(e) => {
        if (uppercase) {
          e.currentTarget.value = e.currentTarget.value.toUpperCase();
        }
      }}
      value={val && val.length > 0 ? val : mask}
      onFocus={(e) => {
        if (isTouchScreen) {
          setFooterDisplay(false);
        }
        // if it's showing the mask, place the cursor at the beginning of the input
        if (e.target.value === mask) {
          e.target.setSelectionRange(0, 1);
        }
      }}
      onBlur={() => {
        if (isTouchScreen) {
          setFooterDisplay(true);
        }
      }}
    />
  );
};

export default MaskedBlock;
